import { openDB } from 'idb';
import type { IContainer } from '../../interface/container';
import { ISettingsKey, ISettingsStorage } from '../interface/settingsStorage';

const KEY_DB_NAME = 'worker-kv-storage';
const KEY_STORE_NAME = 'worker-storage';

const _dbOpen = openDB(KEY_DB_NAME, 1, {
    upgrade(db) {
        db.createObjectStore(KEY_STORE_NAME);
    },
});

function storage(container: IContainer): ISettingsStorage {
    return {
        get: async (key: ISettingsKey) => {
            const db = await _dbOpen;
            return db.get(KEY_STORE_NAME, key);
        },
        set: async (key: ISettingsKey, val: unknown) => {
            const db = await _dbOpen;
            await db.put(KEY_STORE_NAME, val, key);
        },
        delete: async (key: ISettingsKey) => (await _dbOpen).delete(KEY_STORE_NAME, key),
        clear: async () => (await _dbOpen).clear(KEY_STORE_NAME),
        keys: async () => {
            const db = await _dbOpen;
            const keys = await db.getAllKeys(KEY_STORE_NAME);
            return keys as ISettingsKey[];
        },
    };
}

export default storage;
